import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../api'

/**
 * Configuração global de certificado (FCamara). Singleton no back —
 * sempre 1 linha em `certificate_settings`. Usado como fallback quando
 * a empresa do usuário não cadastrou seu próprio template.
 *
 * Acesso: apenas super_admin.
 */
export interface CertificateSettings {
  id: string
  globalBackgroundUrl: string | null
  globalSignatureUrl: string | null
  globalDirectorName: string | null
  globalDirectorRole: string | null
  updatedAt: string
  updatedBy: string | null
}

export interface UpdateCertificateSettingsDTO {
  globalBackgroundUrl?: string | null
  globalSignatureUrl?: string | null
  globalDirectorName?: string | null
  globalDirectorRole?: string | null
}

export function useCertificateSettings() {
  return useQuery({
    queryKey: ['certificate-settings'],
    queryFn: async () => {
      const response = await api.get<CertificateSettings>('/admin/certificate-settings')
      return response.data
    },
  })
}

export function useUpdateCertificateSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (data: UpdateCertificateSettingsDTO) => {
      const response = await api.put<CertificateSettings>('/admin/certificate-settings', data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['certificate-settings'] })
    },
  })
}
